import styled from 'styled-components/macro';

export const RemoveButtonWrapper = styled.div`
  margin-top: 1.5rem;
  text-align: right;
  display: flex;
  justify-content: flex-end;
`;
